// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block-top__body[data-v-11762b85]{background:transparent}[data-v-11762b85] .q-field--standout.q-field--highlighted .q-field__native,[data-v-11762b85] .q-field__native,[data-v-11762b85] .q-select .q-field__input{text-align:center}label[data-v-11762b85]{width:220px}[data-v-11762b85] .q-field__native{font-size:14px!important}", ""]);
// Exports
module.exports = exports;
